<template>
    <div class="country-select-faq">
        <a data-cy="toggle" class="healup-toggle text-center" @click="toggle">
            {{ $t('healup.why.title') }}
            <p><span class="caret"></span></p>
        </a>
        <transition name="fade">
            <div v-if="showCountryInfo" data-cy="info" class="information">
                <div class="arrow"></div>
                <h5 class="heading-normal">{{ $t('healup.why.section1.title') }}</h5>
                <p class="first-section">{{ $t('healup.why.section1.desc') }}</p>

                <h5 class="heading-normal">{{ $t('healup.why.section2.title') }}</h5>
                <p>{{ $t('healup.why.section2.desc') }}</p>

                <i18n v-if="region === 'global'" path="healup.why.link" tag="p">
                    <template v-slot:link>
                        <a
                            href="https://playersupport.nexon.com/hc/en-us/articles/360001135906-Country-Selection-FAQ"
                            target="_blank"
                            data-cy="link-healup-support"
                            rel="external"
                            >{{ $t('support') }}</a
                        >
                    </template>
                </i18n>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'CountrySelectFaq',
    data() {
        return {
            showCountryInfo: false,
        };
    },
    methods: {
        toggle() {
            this.showCountryInfo = !this.showCountryInfo;
        },
    },
};
</script>

<style lang="less" scoped>
.country-select-faq {
    margin: 10px 0;
}
.healup-toggle {
    display: inline-block;
    cursor: pointer;
    text-align: center;
    width: 100%;
    p {
        display: inline-block;
        background-color: #3b3b3b;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        margin: 0 0 0 5px;
        .caret {
            margin-left: 0;
            color: #fff;
        }
    }
    &:hover {
        p {
            background-color: #999;
            .caret {
                color: #fff;
            }
        }
    }
}
.first-section {
    margin-bottom: 15px;
}
.information {
    position: relative;
    background-color: #171a21;
    margin-top: 15px;
    padding: 20px;
    border: 1px solid #333740;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5);
    h5 {
        font-size: 15px;
        color: #fff;
    }
}
.arrow {
    position: absolute;
    background-color: #171a21;
    top: -9px;
    left: 48%;
    width: 16px;
    height: 16px;
    border-left: 1px solid #333740;
    border-top: 1px solid #333740;
    transform: rotate(45deg);
}
</style>
